// extracted by mini-css-extract-plugin
module.exports = {"container":"wy-z","links":"xy-z"};